/**
 * Defines colors used in this web app.
 *
 * NOTE: When adding colors to this list, first consider the palette definitions in `MuiTheme.js` and
 * whether a color from that definition needs to be updated, rather than an ad-hoc color added to the app.
 *
 * *Prefer defining colors via the MUI theme over defining them in components or style blocks.*
 *
 * For details on MUI theme options:
 * @see https://mui.com/material-ui/customization/default-theme/?expand-path=$.palette
 */

export const bouncieBlue = '#1F69F2'; // rgb(31,105,242)
export const blueLight = '#9EBDF4'; // rgb(158, 189, 244)
export const blueLight2 = '#F2F5F9'; // rgb(242 245 249)
export const blueLight3 = '#E1EDFD'; // rgb(225 237 253)
export const blueDark = '#0954E0'; // rgb(9,84,224)
export const blueDark2 = '#091f49'; // rgb(9, 31, 73)

export const orange = '#f99a52'; // rgb(249, 154, 82)
export const orangeAmazon = '#FF6200';
export const red = '#F21F1F'; // rgb(242, 31, 31)

export const black = '#000000'; // rgb(0, 0, 0)
export const fadedBlack = '#5C5C5C'; // rgb(92 92 92)

export const zachBlack = '#2A3141'; // rgb(42,49,65) With respect to Zach Gibson who gave us this color
export const darkGray = '#D5D5D5'; // rgb(213, 213, 213)
export const darkGray2 = '#757575'; // rgb(117, 117, 117)
export const darkGray3 = '#58606F'; // rgb(88, 96, 111)
export const darkGray4 = '#888888'; // rgb(136, 136, 136)
export const gray = '#F5F7FA'; // rgb(245,247,250)
export const gray2 = '#DFDFDF'; // rgb(223, 223, 223)
export const gray3 = '#F2F5F9'; // rgb(242,245,249)
export const gray4 = '#F3F3F3'; // rgb(243, 243, 243)
export const gray5 = '#BFC2C9'; // rgb(191, 194, 201)
export const gray6 = '#DEE1E6'; // rgb(222, 225, 230)
export const gray8 = '#F7F9FB'; // rgb(247, 249, 251)
export const grayLight1 = '#D5D5D5'; // rgb(213 213 213)
export const borderGray = '#BFC2C9'; // rgb(191, 194, 201)
export const softBlue = '#E0E7F5'; // rgb(224 231 245)
export const white = '#ffffff'; // rgb(255,255,255)

export const enterpriseGreen = '#81B81A'; // rgb(129, 184, 26) — enterprise ID linked state
export const enterpriseGreenBg = 'rgba(129, 184, 26, 0.13)'; // enterprise linked panel background
export const enterpriseTuroOrange = '#F5BD23'; // rgb(245, 189, 35) — Turo discount exhausted state
export const enterpriseTuroOrangeBg = 'rgba(245, 189, 35, 0.13)'; // Turo exhausted panel background
